import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "containerCards d-flex flex-column"
}
const _hoisted_2 = { class: "cancel-reason-message" }

import {computed, onMounted, ref, watch, watchEffect} from 'vue';
import { toast } from '@/lib/toast';
import { daysUntil, formatCases, formatDateWithOnlyTime, FORMAT_CASES_DAY, formatMinuteTime } from '../filters';
import ProcedureActions from "./ProcedureActions.vue";
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import GeneralInfo from '../components/procedure/GeneralInfo.vue';
import StatusInfo from "@/components/procedure/StatusInfo.vue";
import Card from "@intec/vue-components/form/Card.vue";
import { useRoute } from "vue-router";
import {useLibraryStore} from "@/stores/library";
import { useProcedureStepStore } from "@/stores/procedureStepStore";
import { useI18n } from 'vue-i18n';

interface Procedure {
  applicationDeadline?: string
  reviewDeadline?: string
  summingStart?: string
  goodName?: string
  registryNumber?: string
  startMaxPrice?: string
  type?: string
  [key: string]: any
  isWithoutStartMaxPrice: boolean
  isNds?: boolean
  cancelReason?: {
    message: string
    date: Date
  }
}

interface Props {
  id?: string
  procedure: Procedure
  result?: object
  types: object[]
  actionsInfo?: object
  status: {
    name: string
    code: string
  }
  loadingDialogText?: string
  loadFunc: (procedureId?: number, isPublicRoute?: boolean) => Promise<void>
  isClosed: boolean,
  showCancelDetails: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcedurePage',
  props: {
    id: {},
    procedure: {},
    result: {},
    types: {},
    actionsInfo: {},
    status: {},
    loadingDialogText: {},
    loadFunc: { type: Function, default: async () => {} },
    isClosed: { type: Boolean },
    showCancelDetails: { type: Boolean, default: false }
  },
  emits: ["update:procedureGoodName", "update:procedureType", "loadError"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const route = useRoute();
const libraryStore = useLibraryStore();

const props = __props;

const emit = __emit

const { t } = useI18n();

const error = ref<boolean>(false);
const loading = ref<boolean>(false);
const confirm = ref(false)

const load = async () => {
  error.value = false;
  loading.value = true;
  try {
    await props.loadFunc(
        parseInt(props.id) || null,
        route.name === 'public.procedures.view'
    );
  } catch (e) {
    error.value = true;
    if (e.status !== '403') {
      toast.error(e.message);
      emit('loadError', e);
    }
  } finally {
    loading.value = false;
  }
}

const procedureStepStore = useProcedureStepStore();

const statusStyle = computed<string>(
    () => props.status && procedureStepStore.getStatusStyle(props.status.code)
);

const isCanceled = computed<boolean>(
    () => props.status && props.procedure.stepCode === 'canceled'
);

const date = computed<string>(() => {
  // Даем стороннему модулю шанс вернуть кастомную дату
  const override = libraryStore.callFunctionByCode('overrideDateText', {
    procedure: props.procedure,
    status: props.status,
  }).overrideDateText ?? null;

  if (typeof override === 'string') {
    return override;
  }

  if (isCanceled.value) {
    let canceledDate = props.procedure.cancelReason ? props.procedure.cancelReason.date : props.procedure.canceledAt;

    return t(`Дата и время отмены: {_1}`, {'_1': formatMinuteTime(canceledDate)});
  }

  const meta = procedureStepStore.getDeadlineMeta(props.status?.code);
  if (!meta) return null;

  const rawDate = props.procedure[meta.field];
  if (!rawDate) return null;

  const formatted = formatDateWithOnlyTime(rawDate);
  const daysLeft: number = daysUntil(rawDate);

  let result = `${meta.label} ${formatted}`;
  if (daysLeft > 0) {
    result += ` (${daysLeft} ${formatCases(daysLeft, FORMAT_CASES_DAY)})`;
  }

  return result;
});

watchEffect(() => {
  if (route.query.action) {
    libraryStore.callActionByCode(route.query.action, { procedure: {id: props.id, ...props.procedure} });
  }
})
onMounted(load);
watch(() => props.id, load);

__expose({
  confirm
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    bg: "",
    "fill-height": "",
    "grid-list-md": "",
    "text-xs-center": "",
    class: "pt-0"
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            align: "start"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "primary"
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : (!error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (props.procedure)
                ? (_openBlock(), _createBlock(GeneralInfo, {
                    key: 0,
                    procedure: props.procedure,
                    name: props.procedure.goodName,
                    type: props.procedure.type,
                    types: _ctx.types,
                    "registry-number": props.procedure.registryNumber,
                    "max-start-price": props.procedure.startMaxPrice,
                    isWithoutStartMaxPrice: props.procedure.isWithoutStartMaxPrice,
                    isClosed: _ctx.isClosed,
                    isNds: props.procedure.isNds,
                    "onUpdate:name": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:procedureGoodName', $event))),
                    "onUpdate:type": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:procedureType', $event)))
                  }, {
                    default: _withCtx(() => [
                      (props.status)
                        ? (_openBlock(), _createBlock(StatusInfo, {
                            key: 0,
                            name: props.status.name,
                            code: props.status.code,
                            result: props.result,
                            date: date.value ? _ctx.$t(date.value) : date.value,
                            "status-style": statusStyle.value
                          }, null, 8 /* PROPS */, ["name", "code", "result", "date", "status-style"]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.actionsInfo)
                        ? (_openBlock(), _createBlock(ProcedureActions, {
                            key: 1,
                            class: "position-relative",
                            item: _ctx.actionsInfo,
                            tableModel: { reload: load }
                          }, null, 8 /* PROPS */, ["item", "tableModel"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["procedure", "name", "type", "types", "registry-number", "max-start-price", "isWithoutStartMaxPrice", "isClosed", "isNds"]))
                : _createCommentVNode("v-if", true),
              (isCanceled.value && _ctx.showCancelDetails)
                ? (_openBlock(), _createBlock(Card, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, {
                        class: "pa-0",
                        "primary-title": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Причина отмены процедуры')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createElementVNode("div", _hoisted_2, _toDisplayString(props.procedure.cancelReason?.message), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _renderSlot(_ctx.$slots, "default")
            ]))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 2,
              align: "start",
              justify: "center",
              class: "d-flex align-self-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { align: "center" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Процедура завершена')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })),
      _createVNode(ConfirmDialog, {
        ref_key: "confirm",
        ref: confirm
      }, null, 512 /* NEED_PATCH */),
      _createVNode(_component_v_dialog, {
        persistent: "",
        width: "300",
        "model-value": !!_ctx.loadingDialogText,
        scrim: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            color: "primary",
            dark: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.loadingDialogText ? _ctx.$t(_ctx.loadingDialogText) : _ctx.loadingDialogText) + " ", 1 /* TEXT */),
                  _createVNode(_component_v_progress_linear, {
                    indeterminate: "",
                    color: "white",
                    class: "mb-0"
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model-value"])
    ]),
    _: 3 /* FORWARDED */
  }))
}
}

})